module.exports = require("plugin-liverig/shared/enums/TypeImages");